import { render, staticRenderFns } from "./dialogReBuy.vue?vue&type=template&id=0564d414&scoped=true&"
import script from "./dialogReBuy.vue?vue&type=script&lang=js&"
export * from "./dialogReBuy.vue?vue&type=script&lang=js&"
import style0 from "./dialogReBuy.vue?vue&type=style&index=0&id=0564d414&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0564d414",
  null
  
)

export default component.exports